// Client-side instrumentation (Next.js loads this on every page).
//
// First-party session replay (lib/replay/recorder) starts after the
// visitor's first move (a scroll, tap, key or pointer move) or 8 s,
// whichever comes first, then waits for an idle moment; sampling and the
// secret-field checks live inside. It started at the first idle moment
// before, ~2 s after hydration, and its full-page snapshot (120-250 ms
// of main thread) landed in the page's load window on every page
// (Google's run, 2026-10-27). The fingerprint waits the same way. PostHog used to load at this same
// moment; it is gone (owner, 2026-10-16): product events go to our own
// tracking_events through lib/tracking.captureEvent.
//
// This file imports no app module at the top level (the Turbopack note
// in lib/tracking.ts): the recorder arrives through a dynamic import.

// Automated browsers (Lighthouse, Playwright, crawlers that render JS)
// are not people: they are never recorded.
const automated = typeof navigator !== "undefined" && navigator.webdriver;
const ownReplay = Number(process.env.NEXT_PUBLIC_REPLAY_SAMPLE || 0) > 0;

function startOwnReplay() {
  if (ownReplay && !automated) {
    void import("@/lib/replay/recorder").then(({ startReplay }) => startReplay()).catch(() => {});
  }
}

if (typeof window !== "undefined" && ownReplay && !automated) {
  type RIC = (cb: () => void, opts?: { timeout?: number }) => number;
  const ric = (window as unknown as { requestIdleCallback?: RIC }).requestIdleCallback;
  const events = ["pointerdown", "pointermove", "keydown", "scroll", "touchstart", "wheel"] as const;
  let armed = true;
  const go = () => {
    if (!armed) return;
    armed = false;
    events.forEach((ev) => window.removeEventListener(ev, go, true));
    window.clearTimeout(timer);
    // After the move is handled, not inside it.
    if (ric) ric(startOwnReplay, { timeout: 2000 });
    else setTimeout(startOwnReplay, 200);
  };
  events.forEach((ev) => window.addEventListener(ev, go, { passive: true, capture: true }));
  const timer = window.setTimeout(go, 8000);
}
